export default __webpack_public_path__ + "locales/statements.ky.json";